<template>
    <div class="info-card">
        <span class="content"><slot /></span>
        <span class="icon" test-id="info_card-icon">i</span>
    </div>
</template>

<script>
export default {
    name: 'LsInfoCard',
};
</script>

<style lang="scss" scoped>
.info-card {
    display: flex;
    align-items: center;
    background-color: $secondary-lighter;
    padding: 15px;
    position: relative;
    .icon {
        color: $white;
        background-color: $secondary;
        font-size: $size-5;
        font-weight: $semi-bold;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        position: absolute;
        left: 15px;
        top: 15px;
        display: flex;
        justify-content: center;
        align-items: flex-end;
    }
    .content {
        margin: 0 0 0 27px;
    }
}
</style>
